module.exports = __webpack_public_path__ + "static/drc.3c6b1c3e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/public_sector_logos/drc.jpg
// module id = 2219
// module chunks = 61762850755587